<template>
  <div class="store-details-block is-flex is-flex-column justify-content-between">
    <div class="store-details-top bg-white selected-store-wrapper store-details-wrapper mt0 ph15 pt15 pb15" v-if="isEmptyObj(vg_selectedStore) == false">
      
      <template v-if="product.selected_location_product_variants.length > 0">
       
        <!-- this is select view -->
        <div class="product-attr sizes-section product-sizes mb30" v-if="(variantDisplayType == 'select') && (totalNumberOfAddableVariants > 0)">
          <div class="title is-size-6 attr-title has-text-weight-bold">Select size</div>
          <select v-model="selectedVariant" class="has-text-dark select-product-variant font-color">
            <option :value="{}" selected>Please Choose:</option>
            <option :disabled="item._in_stock == false" :value="item" v-for="item in product.selected_location_product_variants" v-bind:key="'select_item_variant_' + item.id">{{ item.size }}</option>
          </select>
        </div>


        <!-- this is item view -->
        <div class="product-attr sizes-section product-sizes mb30" v-if="variantDisplayType == 'list'">
          <div class="title is-size-6 attr-title has-text-weight-bold">Select size</div>
          <div class="columns is-multiline is-flex-mobile" v-if="product">
            <div :class="checkVariantAlreadySubscribed(variant) ? 'column is-3-widescreen has-fixed-variant-width is-3-mobile is-6-tablet relative subscribed mb10' : 'mb10 column has-fixed-variant-width is-3-mobile is-3-widescreen is-6-tablet relative'" v-bind:key="'variant_' + index" v-for="(variant, index) in product.selected_location_product_variants">
              <div class="product-detail-variant-item">
                <a v-if="!variant._in_stock" href="#" class="outof-stock-overlay" @click.prevent="showOutOfStockNotification(variant)"></a>
                <div @click.prevent="selectVariant(variant)" :class="variant._in_stock == false ?  'control is-out-of-stock variant-block has-text-centered mb10 is-flex-direction-column cursor-pointer' : 'control variant-block has-text-centered is-flex-direction-column cursor-pointer' + (variantHasSalePrice(variant) ? ' has-sale' : '')">
                  <input class="is-checkradio is-block" :id="'product-variant-' + index + type" type="radio"
                    :name="'product-variant'+type" v-model="selectedVariant" :value="variant">
                  <label :for="'product-variant-' + index + type"
                    :class="'is-flex is-flex-column align-items-center justify-content-center cursor-pointer ' + (variantHasSalePrice(variant) ? 'has-sale-tag': '')">
                    <div class="variant-item-block has-text-centered">
                      <div class="variant-weight has-text-weight-semibold font-color py-10">{{ variant.size }}</div>
                    </div>
                  </label>
                  <div class="sale-attach is-size-13" v-if="variantHasSalePrice(variant)">
                    {{ variantSalePercentage(variant) }}
                  </div>
                </div>
              </div>

              <div class="variant-attributes-at-footer">
                <div class="variant-price has-text-weight-bold">${{ (variantHasSalePrice(variant)) ? variant.sale_price.toFixed(2) : variant.price.toFixed(2) }}</div>
                <div class="variant-unit-price has-text-centered" v-if="product.product.product_family == 'cannabis'">
                  <template v-if="variant.weight_equivalent_dry_cannabis != '0.00' && variant.weight_equivalent_dry_cannabis != null">
                    <div v-html="itemPricePerWeight(variant)"></div>
                    <!-- <span class="price">${{ ( (variantHasSalePrice(variant) ? variant.sale_price : variant.price ) / variant.weight_equivalent_dry_cannabis).toFixed(2) }}</span>  
                    <span class="weight">/{{ product.product.weighing_unit ? product.product.weighing_unit : 'g'}}</span> -->
                  </template>
                </div>
              </div>

            </div>
          </div>
        </div>
      </template>

      <div class="product-attr product-sizes mb30" v-else>
        <div class="title attr-title has-text-danger">Product not available.</div>
      </div>

      <div class="product-quantity" v-if="isEmptyObj(vg_selectedStore) == false && product.selected_location_product_variants.length > 0">
        <div class="title quantity-title">
          <div class="is-flex justify-content-between">
              <div>
                Subtotal
              </div>
              <div v-if="totalNumberOfAddableVariants > 0">
                <span class="regular-price" v-if="variantHasSalePrice(selectedVariant)"><s>${{ selectedVariatRegularPrice }}</s></span> <span class="actual-price">${{ selectedVariantActualPrice }}</span>
              </div>
              <div v-else>
                <span class="">Out of Stock</span>
              </div>
          </div>
        </div>

        <div class="quantity-block is-flex justify-content-between">
          <button value="-" @click="decreaseQty()" class="button minus is-borderless "><i class="fas fa-minus"></i></button>
          <div class="field mb0">
            <div class="control disable-click-event">
               <span v-text="qty" class="font-color has-text-weight-bold display-qty"></span>
            </div>
          </div>
          <button  @click="increaseQty()" value="+" class="button plus is-borderless "><i class="fas fa-plus"></i></button>
        </div>

        <div class="product-detail-add-to-cart">
          <div class="store-details-bottom add-to-cart-nd-wrap is-hidden-mobile" v-if="isEmptyObj(vg_selectedStore) == false && product.selected_location_product_variants.length > 0 && product.product.discontinued != true && totalNumberOfAddableVariants > 0">
            <a
              @click.prevent="addToCart()"
              v-if="!isEmptyObj(selectedVariant)"
              class="button is-flex is-primary add-to-cart-btn has-text-weight-bold">
              ADD TO STASH
            </a>
             <a
              v-else
              class="button is-flex justify-content-between has-background-danger has-text-semibold-18">
              <span class="add-to-cart">Please select a variant.</span>
            </a>
          </div>

          <div class="store-details-bottom" v-if="product.product.discontinued == true || totalNumberOfAddableVariants == 0">
            <a
              class="button is-flex justify-content-between  has-background-danger  has-text-semibold-18">
              <span class="add-to-cart">Product currently not available !</span>
            </a>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import { indexOf, isEmpty, find, clone } from 'lodash';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import Helpers from '@/Components/Helpers/Helpers';
import moment from "moment";
import ProductApis from '@/Components/Controllers/ProductApis';

export default {
  name: 'ProductDetailSelectedStore',
  data() {
    return {
      aaaa: [],
      qty: 1,
      totalNumberOfAddableVariants: 0,
      variantDisplayType: 'list',
      selectedVariant: {
      },
      subscribedOutOfstockNotifications: [],
    };
  },
  props: ['product', 'type'],

  computed: {
    ...mapGetters({
      vg_cartId: 'cart/id',
      vg_cartItems: "cart/cartItems",
      vg_cartItemsIds: "cart/cartItemsIds",
      vg_selectedStore: "location/selected",
      vg_weightOnCart: "cart/cartWeight",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_guestLandedQueries: "location/guestLandedQueries",
    }),
    is_user_logged_in() {
      return this.$store.getters.getLoggedInUserToken;
    },
    selectedVariantActualPrice() {
      if(isEmpty(this.selectedVariant)){
        return 0.00.toFixed(2);
      }
      if(parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price)){
        return (this.selectedVariant.sale_price * this.qty).toFixed(2);
      }
      return (this.selectedVariant.price * this.qty).toFixed(2);
    },
    selectedVariatRegularPrice() {
      return (this.selectedVariant.price * this.qty).toFixed(2);
    }
  },

  async mounted() {
    // Get the display type for variant
    this.variantDisplayType = Helpers.getVariantDisplayType(this.product.selected_location_product_variants);
    this.totalNumberOfAddableVariants = Helpers.getTotalNumberOfAddableVariants(this.product.selected_location_product_variants);

  
     if(this.totalNumberOfAddableVariants == 1){
      // if the available variant is only 1 make it auto selected
      this.selectedVariant =  Helpers.getFirstAvailableVariant(this.product.selected_location_product_variants);
    }
   
    // fetch noptification if user is logged in 
    if(this.$store.getters.getLoggedInUserToken){
      this.fetchUserOutOfStockNotification();
    }

    bus.$on('refetch-outof-stock-notification', (payload) => {
      if(payload == true){
        this.fetchUserOutOfStockNotification();
      }
    })
    
    // listen to any pending order on login to cart
    bus.$on('listen-pending-cart-item', (payload) => {
      if(!_.isEmpty(payload)) { 
        this.addToCart();
      }
    })

    bus.$on('listen-mobile-addtocart', () => {
      // listen from mobile screen
      if(this.type == 'sm'){
        this.addToCart();
      }
    })

    // G track impression
    this.$gtag.event('view_item', 
      {
        items: [{ 
        id: this.product.product.id,  
        name: this.product.product.name, 
        list: null,
        brand: this.product.product.brand ? this.product.product.brand.name : null,
        category: this.product.product.category ? this.product.product.category.name : null,
        variant: this.selectedVariant.size,
        position: '',
        price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price,
        }]
      }
    )
  },

  beforeDestroy() {
    bus.$off('listen-mobile-addtocart');
    bus.$off('refetch-outof-stock-notification');
    bus.$off('listen-pending-cart-item');
  },

  methods: {

    /**
     * Select variant
     * 
     */
    selectVariant(variant) {
      this.selectedVariant = variant
    },
    /**
     * fetch user product subscribe notifications 
     */
    async fetchUserOutOfStockNotification(){
      let res = await UserApis.listOutOfstockNotification(this.$route.params.product_id);
      this.subscribedOutOfstockNotifications = res.data.payload;
    },

    /**
     * Check variant is on subscription or not
     */
    checkVariantAlreadySubscribed(variant) {
      let subscribed = _.find(this.subscribedOutOfstockNotifications, { location_product_id: variant.location_product_id, location_product_varaint_id: variant.id });
      if(subscribed == undefined){
        return false;
      }
      return true;
    },
  
    /**
     * Store hours 
     * 
     */
    getOpenCloseTime(item) {
      let schedule = _.find(item, function(o) { return o.day_name == moment().format("dddd"); });
      if(schedule != undefined){
        return `<span class="time">${ moment(schedule.open_time, "HH:mm:ss").format("hh:mm a") } - ${ moment(schedule.close_time, "HH:mm:ss").format("hh:mm a") }</span>`;
      }
      return '';
    },

    /**
     * Get store featured image
     */
    getStorefeaturedImage(images) {
      return Helpers.getStoreFeaturedImage(images);
    },

    /**
     * Check empty
     */
    isEmptyObj(obj) {
        for(var prop in obj) {
          if(obj.hasOwnProperty(prop))
            return false;
        }
      return true;
    },
    /**
     * Out of stock notification
     */
    showOutOfStockNotification(variant) {
      // for now
      return this.va_snackbar({
        type: 'warning', 
        message: 'Item is out of stock',
      });

      if( (this.vg_guestLandedQueries['guest-only'] && this.vg_guestLandedQueries['guest-only'] == 'true') || this.$route.query['guest-only']){
        return this.va_snackbar({
          type: 'warning', 
          message: 'Item is out of stock',
        });
      }
      if(!this.$store.getters.getLoggedInUserId){
      this.va_snackbar({
        type: 'warning', 
        message: 'Please login to proceed.',
      });
       return;
      }
      bus.$emit('show-modal-out-of-stock', {
        modal: true,
        product: this.product.product,
        variant: variant,
      });
    },

    /**
     * Change store modal
     */
    changeStore() {
      bus.$emit('show-modal-change-store-notice', true);
    },
    /**
     * Add item on cart
     * 
     */
    async addToCart() {
      
      // Send user activy emit, user , location details verified within the function
      Helpers.emitUserActivity();

      // if we dont have cart id create cart first 
      if(this.vg_cartId == ''){
        await CartApis.createCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
      }

      // threshold 
      if(this.totalNumberOfAddableVariants < 1){
        this.va_snackbar({
          type: 'warning', 
          message: 'Products variants are not available.',
        });
        return;
      }
      
      // we were doing to store the item and after login adding to cart
      // if(!this.$store.getters.getLoggedInUserId){
      //    this.va_setPendingItem({
      //      id: this.$route.params.product_id,
      //      variant: this.selectedVariant,
      //    })
      //   // Here before we login we must add this item as pending order and as soon as user login we must pass it 
      //   bus.$emit('show-modal-user-not-loggedin-product-detail', true);
      //   return;
      // }

      // Check if variant is selected 
      if( _.isEmpty(this.selectedVariant) ) {
        this.va_snackbar({
          type: 'warning', 
          message: 'Please select a variant.',
        });
        return;
      }
      // If already exceed limit
      if(parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit) ){
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
        return false;
      }
  
      // If going to exceed limit on adding this item
      let currentProductWeight = this.qty * parseFloat(this.selectedVariant.weight_equivalent_dry_cannabis);
      let finalWeight = parseFloat(currentProductWeight) + parseFloat(this.vg_weightOnCart);
      if(finalWeight > parseFloat(this.vg_cannabisLimit) ) {
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: finalWeight,
          modal: true,
        });
        return false;
      }

      let checkExistingProduct = _.find(this.vg_cartItems, { location_product_id: parseInt(this.$route.params.product_id), location_product_variant_id: parseInt(this.selectedVariant.id) });
      if(checkExistingProduct == undefined){
        // validate if we have instock
        if(parseInt(this.qty) > this.selectedVariant.no_of_units){
          // reject cannot add qty more than no of units
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        let addedProduct = await this.addCartItem();
        if(addedProduct){
          let recommendProductsRes = await ProductApis.fetchRecommendProductsByLocationProductIds({
            location_products_ids: this.vg_cartItemsIds
          }) 
          if(recommendProductsRes.status == 200){
            let collectrecommendProducts = Helpers.collectRecommendProducts(recommendProductsRes.data.payload);
            if(collectrecommendProducts.length > 0){
              bus.$emit('added-to-cart-recommend-products', {
                modal: true,
                addedProduct: addedProduct,
                recommendProducts: collectrecommendProducts
              })
            }
          }
        }
        this.va_spinner(false);
      } else {

        // Now before update lets check no of qty he can add
        let existingProductQty = checkExistingProduct.unit;
        let maxCanBeAdded = parseInt(this.selectedVariant.no_of_units) - parseInt(existingProductQty);
        if(parseInt(this.qty) > maxCanBeAdded){
          // reject cannot add qty more than no of units
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        this.updateCartItem(checkExistingProduct);
      }
    },

    /**
     * Add cart item
     */
    async addCartItem() {
      let obj = {
        user_id: this.$store.getters.getLoggedInUserId,
        location_id: this.vg_selectedStore.id,
        cart_id: this.vg_cartId == '' ? 'Not available' : this.vg_cartId,
        location_product_id: this.product.product.id,
        category_name: this.product.product.category ? this.product.product.category.name : null,
        thc_cbd_value_type: this.product.product.category ? this.product.product.category.thc_cbd_value_type : '',
        category_id: this.product.product.category ? this.product.product.category.id : null,
        product_name: this.product.product.name,
        product_family: this.product.product.product_family,
        product_id: this.product.product.id,
        product_image: this.product.product.image ? this.product.product.image : 'http://unohop.dev.unoapp.io/img/leaf.47bfc5db.png',
        product_type: this.product.product.product_type ? this.product.product.product_type : '',
        brand_name: this.product.product.brand ? this.product.product.brand.name : '',
        location_product_variant_id: this.selectedVariant.id,
        location_variant_sku: this.selectedVariant.sku,
        location_product_variant_external_sku: this.selectedVariant.external_id,
        price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price, // if has sale price & sale must be lower than regular, then use sale else regular price
        actual_price: this.selectedVariant.price,
        weight: this.selectedVariant.weight_equivalent_dry_cannabis ? this.selectedVariant.weight_equivalent_dry_cannabis : 0,
        unit: parseInt(this.qty),
        app_version: Env.appVersion,
        platform: Env.appPlatform,
        //product: this.product.product, // triple to match fav style
        selected_variant: this.selectedVariant,
        weighing_unit: this.product.product.weighing_unit ? this.product.product.weighing_unit : 'null',
      }
      // Add THC,CBD,cannabis attributes only if family is cannabis
      if(this.product.product.product_family == 'cannabis'){
        obj.cannabis_attributes = this.product.product.cannabis_attributes ? Helpers.unsetKeyFromObj(['createdAt', 'updatedAt', 'created_at', 'updated_at'], this.product.product.cannabis_attributes) : {};
        obj.thc_cbd_levels = this.product.product.thc_cbd_levels ? Helpers.unsetKeyFromObj(['created_by', 'createdAt', 'updated_by', 'updatedAt', 'created_at', 'updated_at'], this.product.product.thc_cbd_levels) : {};
      }

      let res = await CartApis.add(obj, this);
      if(res.status == 200) {
        // we get cart id here assign it
        this.va_setCartId(res.data.payload.id);
        this.va_setCartDetail(res.data.payload);
        
        if(this.is_user_logged_in == false){
          // If guest user 
          this.va_snackbar({
            message:  res.data.msg,
            type: 'success',
          });
        } else {
          // lets save the data on vbout
          // obj.description = this.product.product.description; not any more
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(obj.product_id), this.vg_selectedStore.id);
        }
        
        // G tracking add to cart
        this.$gtag.event('add_to_cart', { 
          items: [
            {
              id: this.product.product.id,
              name: this.product.product.name, 
              brand: this.product.product.brand ? this.product.product.brand.name : null,
              category: this.product.product.category ? this.product.product.category.name : null,
              variant: this.selectedVariant.size ? this.selectedVariant.size : null,
              quantity: parseInt(this.qty),
              price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price,
            }
          ]
        });

        return obj;

      } else {
        this.va_snackbar({
          message: res.status == 200 ? res.data.msg : res.response.data.payload[0],
          type: res.status == 200 ? 'success' : 'error',
        });
        return false;
      }

    },

     /**
     * Update cart item
     */
    async updateCartItem(item) {
      this.va_spinner(true);
      //Clone the object and filter
      var obj = _.clone(item);
      obj.cart_item_id = item.id;
      obj.unit = parseInt(item.unit) + parseInt(this.qty);
      obj.app_version = Env.appVersion;
      obj.platform = Env.appPlatform;
      let res = await CartApis.update(obj);
      this.va_spinner(false);
      if(res.status == 200) {
        if(this.is_user_logged_in == false){
          // If guest user 
          this.va_snackbar({
            message: res.data.msg,
            type: 'success',
          });
        }
      } else {
        this.va_snackbar({
          message: res.response.data.msg ? res.response.data.msg : Helpers.catchErrorMessage(res.response.data),
          type: res.response.status == 200 ? 'success' : 'error',
        });
      }
    
    },
  /**
   * Increase qty
   */
    increaseQty() {
      this.qty = this.qty + 1;
    },
    /**
     * Decrease qty
     */
    decreaseQty() {
      if(this.qty > 1){
        this.qty = this.qty - 1;
      }
    },

    /**
     * Variant sale price
     */
    variantHasSalePrice(item) {
      // parseFloat(item.sale_price) > 0 && 
      if((parseFloat(item.sale_price) < parseFloat(item.price)) ){
        return true;
      }
      return false;
    },

    /**
     * Sale percentage
     */
    variantSalePercentage(item) {
      let salePercentData =  ((item.price-item.sale_price) / item.price)*100;
      return ((salePercentData - Math.floor(salePercentData)) ? salePercentData.toFixed(0) : salePercentData) + '% off';
    },

     itemPricePerWeight(variant) {
       // DO not show price per gram for non dried flower
      if(this.product.product.cannabis_attributes && ( (this.product.product.cannabis_attributes.product_form == 'dried flower' ) || (this.product.product.cannabis_attributes.product_form == 'pre rolled') ) ){
        if(variant && (variant.weight_equivalent_dry_cannabis != null) ){
          let dryEquiWeight = parseFloat(variant.weight_equivalent_dry_cannabis);
          if(variant.sale_price && (variant.sale_price < variant.price) ){
            if(dryEquiWeight == 0){
              return '<span class="price">$' + (variant.sale_price).toFixed(2) + '/' + this.product.product.weighing_unit + '</span>';
            }
            return '<span class="price">$' + (variant.sale_price/dryEquiWeight).toFixed(2) + '/' + this.product.product.weighing_unit + '</span>';
          }
          if(dryEquiWeight == 0){
              return '<span class="price">$' + (variant.price).toFixed(2) + '/' + this.product.product.weighing_unit + '</span>';
            }
          return  '<span class="price">$' + (variant.price/dryEquiWeight).toFixed(2) + '/' + this.product.product.weighing_unit + '</span>';
        }
      } else {
        return ''; // blank for now
        if(variant.sale_price && (variant.sale_price < variant.price) ){
          return '<span class="price">$' + (variant.sale_price).toFixed(2) + '/' + this.product.product.weighing_unit + '</span>';
        } else {
          return '<span class="price">$' + (variant.price).toFixed(2) + '/' + this.product.product.weighing_unit + '</span>';
        }
      }
    },

    ...mapActions({
      va_setCartId: "cart/setId",
      va_setCartDetail: "cart/setCartDetail",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setPendingItem: "cart/setPendingItem",
    })

  },
};
</script>

<style scoped>
.is-out-of-stock {
    pointer-events: none;
}
.relative{
  position: relative;
}
.outof-stock-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}
.product-detail-wrapper .store-item img{
  min-height: 60px;
}
</style>


